<template>
    <v-container grid-list-md>
        <v-layout row wrap>
            <v-flex xs12 md2>
                <v-container grid-list-md>
                    <v-flex>
                        <h3>Grupos</h3>
                        <v-list>
                            <v-list-tile v-for="(grupo, key_grupo, id_grupo) in bases.grupos" :key="id_grupo" v-if="bases.grupos && Object.keys(bases.grupos).length && grupo">
                                {{grupo.nombre}}
                            </v-list-tile>
                            <v-list-tile avatar>
                                <v-list-tile-content>
                                    <v-text-field label="Nombre del Grupo" v-model="nuevoGrupo" style="width: 100%;" @keyup.enter="agregarG" color="black"></v-text-field>
                                </v-list-tile-content>

                                <v-list-tile-action>
                                    <v-icon light @click="agregarG">add_circle</v-icon>
                                </v-list-tile-action>
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-container>
            </v-flex>
            <v-flex xs12 md10 style="border-left: 1px solid #EBEBEB;">
                <v-container grid-list-md>
                    <v-flex v-for="(grupo, key_grupo, id_grupo) in bases.grupos" :key="id_grupo" v-if="bases.grupos && Object.keys(bases.grupos).length && grupo">
                        <GrupoGrid :grupoLista="grupo" />
                    </v-flex>
                </v-container>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import GrupoGrid from '../../components/bases/GrupoGrid'

  export default {
    name: 'bases',
    data() {
      return {
        test: { "id": 1, "nombre": "Vlive Media" },
        nuevaBase: [],
        nuevoGrupo: ''
      }
    },
    components: { GrupoGrid },
    computed: {
      ...mapState({ bases: state => state.bases })
    },
    methods: {
      ...mapActions('bases', ['obtenerGrupos', 'obtenerBases', 'agregarGrupo']),
      ...mapActions(['cambiarTitulo']),
      agregarG () {
        this.agregarGrupo(this.nuevoGrupo)
        this.nuevoGrupo = ''
      },
      actualizarEstado() {
        this.obtenerGrupos()
        this.obtenerBases()
      }
    },
    mounted () {
      this.cambiarTitulo('Bases')
      this.obtenerGrupos()
      this.obtenerBases()
    }
  }
</script>

<style scoped>
    .grupo_titulo {
        text-decoration: underline;
    }
    .grupo_flecha {
        height: 18px;
        width: 18px;
        top: -5px;
    }
</style>